import React from 'react'
import { Select } from 'antd'

export const statusFilterMethod = (filter, row) => {
  const activeArray = ['Approved', 'Confirmed', 'Submitted', 'Revised', 'Draft']
  const draftArray = ['Draft']
  const nonActiveArray = ['Closed', 'Delivered', 'Cancelled']
  if (filter.value === 'all') {
    return row[filter.id] !== 'All'
    //return true
  }
  if (filter.value === 'draft') {
    return draftArray.includes(row[filter.id])
  }
  if (filter.value === 'delivered') {
    return row[filter.id] === 'Delivered'
  }
  if (filter.value === 'held') {
    return row[filter.id] === 'Held'
  }
  if (filter.value === 'not-cancelled') {
    return row[filter.id] !== 'Cancelled'
  }
  if (filter.value === 'submitted') {
    return row[filter.id] === 'Submitted'
  }
  else return filter.value === true
    ? activeArray.includes(row[filter.id])
    : nonActiveArray.includes(row[filter.id])
}

function StatusFilter({ onChange, filter }) {
  return (
    <Select
      onChange={value => onChange(value)}
      style={{ width: '100%' }}
      value={filter ? filter.value : true}>
      <Select.Option value={'draft'}>Draft</Select.Option>
      <Select.Option value="all">All</Select.Option>
      <Select.Option value="delivered">Delivered</Select.Option>
      <Select.Option value={'held'}>Held</Select.Option>
      <Select.Option value={'not-cancelled'}>Not Cancelled</Select.Option>
      <Select.Option value={'submitted'}>Submitted</Select.Option>
      <Select.Option value={true}>Active</Select.Option>
      <Select.Option value={false}>None Active</Select.Option>
    </Select>
  )
}

StatusFilter.propTypes = {}
StatusFilter.defaultProps = {}

export default StatusFilter
